/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Import_FilesInputs */

const en_google_drive_import_files = /** @type {(inputs: Google_Drive_Import_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import files from Drive`)
};

const es_google_drive_import_files = /** @type {(inputs: Google_Drive_Import_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa archivos de Drive`)
};

/**
* | output |
* | --- |
* | "Import files from Drive" |
*
* @param {Google_Drive_Import_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_import_files = /** @type {((inputs?: Google_Drive_Import_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Import_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_import_files(inputs)
	return en_google_drive_import_files(inputs)
});